import axios from "axios";
import { get } from "lodash";
import AppConfiguration from "../dataProvider/config";

let ghtkTokenStr = localStorage.getItem("ghtk-token-storage");

const requestHeader = {
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,POST,PUT,DELETE,OPTIONS",
  "Access-Control-Allow-Headers":
    "Origin,Authorization,Content-Type,Accept,User-Agent,Cache-Control,Keep-Alive,X-Requested-With,If-Modified-Since",
  timeout: 180000
};
if (ghtkTokenStr) {
  let ghtkTokenStorage = JSON.parse(ghtkTokenStr);
  let accessToken = get(ghtkTokenStorage, "accessToken.accessToken", "");
  if (accessToken) {
    requestHeader["Authorization"] = `Bearer ${accessToken}`;
  }
}
const axiosConfig = {
  baseURL: AppConfiguration.apiBaseMap,
  headers: requestHeader
};

const axiosConfigBlob = {
  baseURL: AppConfiguration.apiBaseMap,
  headers: requestHeader,
  responseType: "arraybuffer"
};

export const axiosBlobInstance = axios.create(axiosConfigBlob);
axiosBlobInstance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    const errRes = error.response;
    if (errRes) return errRes;
  }
);

const axiosInstance = axios.create(axiosConfig);
axiosInstance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (403 === error.response?.status) {
      const errRes = error.response;
      if (errRes) return errRes;
    } else {
      return Promise.reject(error);
    }
  }
);

export default {
  //lấy danh sách kho có cân
  getSmartScaleStations() {
    let api = `/device/v1/scale/get-smart-scale-stations`;
    return axiosInstance.get(api);
  },
  //tạo cân mới
  createSmartScale(data) {
    let api = `/device/v1/scale/create-scale`;
    return axiosInstance.post(api, data);
  },
  //lấy danh sách tên cân
  getSmartScaleName() {
    let api = `/device/v1/scale/get-scale-name`;
    return axiosInstance.get(api);
  },
  //lấy danh sách màn hình cân
  getSmartScale(params) {
    let api = `/device/v1/scale/find-scale`;
    return axiosInstance.get(api, { params });
  },
  //lấy log sửa chữa của cân
  getSmartScaleRepairLog(params) {
    let api = `/device/v1/scale/get-scale-repair-log`;
    return axiosInstance.get(api, { params });
  },
  //thêm log sửa chữa cho cân
  updateSmartScale(data) {
    let api = `/device/v1/scale/update-scale`;
    return axiosInstance.post(api, data);
  },
  //xuất file cân
  exportSmartScaleList(params) {
    let api = `/device/v1/scale/export-scale-list`;
    return axiosBlobInstance.get(api, { params });
  },
  //xoá cân khỏi màn hình
  deleteSmartScale(id) {
    let api = `/device/v1/scale/delete-scale`;
    return axiosInstance.delete(api, { params: { id } });
  },
  //xoá log sửa chữa cân khỏi lịch sử sửa chữa
  deleteSmartScaleRepairLog(id) {
    let api = `/device/v1/scale/delete-repair-log`;
    return axiosInstance.delete(api, { params: { id } });
  },
  //lấy danh sách màn hình cam
  getSmartScaleCamera(params) {
    let api = `/device/v1/scale/find-camera`;
    return axiosInstance.get(api, { params });
  },
  //xoá cam khỏi màn hình
  deleteSmartScaleCamera(id) {
    let api = `/device/v1/scale/delete-camera`;
    return axiosInstance.delete(api, { params: { id } });
  },
  //gán camera cho cân
  addSmartScaleCamera(data) {
    let api = `/device/v1/scale/add-camera`;
    return axiosInstance.post(api, data);
  },
  //tạo camera mới
  createSmartScaleCamera(data) {
    let api = `/device/v1/scale/create-scale-camera`;
    return axiosInstance.post(api, data);
  },
  //update thông tin cam
  updateSmartScaleCamera(data) {
    let api = `/device/v1/scale/update-scale-camera`;
    return axiosInstance.post(api, data);
  },
  // lấy list cân + mac cân theo kho
  getSmartScaleByStation(params) {
    let api = `/device/v1/scale/find-scale-in-station`;
    return axiosInstance.get(api, { params });
  },
  // lấy danh sách màn hình ảnh đơn hàng
  getSmartScaleImageOrder(params) {
    let api = `/device/v1/scale/find-images`;
    return axiosInstance.get(api, { params });
  },
  //lấy danh sách ảnh chụp cuối cùng từ các kho
  getSmartScaleLastImageInfo() {
    let api = `/device/v1/scale/get-last-scale-image-infos`;
    return axiosInstance.get(api);
  },
  //lấy thống kê cân
  getSmartScaleStatistics(params) {
    let api = `/device/v1/scale/scale-statistics`;
    return axiosInstance.get(api, { params });
  },
  //lấy thống kê cân
  exportSmartScaleLog(params) {
    let api = `/device/v1/scale/export-log`;
    return axiosInstance.get(api, { params });
  },
  // lấy danh sách kho màn smart scale logs
  getSmartScaleLogStations() {
    let api = `/device/v1/scale/station`;
    return axiosInstance.get(api);
  },
  // Kiểm tra sensor cân màn
  getSmartScaleDepthSensor(params) {
    let api = `/device/v1/scale/check-depth-sensor`;
    return axiosInstance.get(api, { params });
  },
  // lấy danh sách đơn chiều cao bất thường
  getSmartScaleAbnormalHeight(params) {
    let api = `/device/v1/scale/abnormal-log`;
    return axiosInstance.get(api, { params });
  },

  // Smart Scale V2
  getSmartBarcodeScaleLog(params) {
    let api = `/device/v1/smart-scale/logs`;
    return axiosInstance.get(api, { params });
  },
  getSmartBarcodeScaleLogV2(params) {
    let api = `/device/v1/smart-scale/package-log`;
    return axiosInstance.get(api, { params });
  },
  getScaleFilter() {
    let api = `/device/v1/scale/filters`;
    return axiosInstance.get(api);
  },
  getScreenFilter() {
    let api = `/device/v1/smart-scale/logs/filters`;
    return axiosInstance.get(api);
  },

  getSmartScaleV2(params) {
    let api = `/device/v1/smart-scale`;
    return axiosInstance.get(api, { params });
  },
  exportSmartScaleV2(params) {
    let api = `/device/v1/scale/export-scale-list`;
    return axiosBlobInstance.get(api, { params });
  },
  deleteSmartScaleV2(mac) {
    let api = `/device/v1/smart-scale/${mac}`;
    return axiosInstance.delete(api);
  },
  getSmartScaleV2RepairLog(params) {
    let api = `/device/v1/scale/get-scale-repair-log`;
    return axiosInstance.get(api, { params });
  },
  createSmartScaleV2(data) {
    let api = `/device/v1/smart-scale`;
    return axiosInstance.post(api, data);
  },
  updateSmartScaleV2(data) {
    let api = `/device/v1/smart-scale/${data.mac}`;
    return axiosInstance.put(api, data);
  },
  deleteSmartScaleV2RepairLog(params) {
    let api = `device/v1/smart-scale/repair-logs/${params.scale_id}/${
      params.repair_log_id
    }`;
    return axiosInstance.delete(api);
  },
  updateSmartScaleV2Repair(data) {
    let api = `/device/v1/smart-scale/repair-logs`;
    return axiosInstance.post(api, data);
  },

  // Flash scanner
  getFlashScannerList(params) {
    let api = `/device/v1/flash-scanner/logs`;
    return axiosInstance.get(api, { params });
  },

  getFlashScannerLogs(params) {
    let api = `/device/v1/scanner/logs`;
    return axiosInstance.get(api, { params });
  },

  unlockSmartScale(data) {
    let api = `/device/v1/scale/lock`;
    return axiosInstance.post(api, data);
  }
};
